import './lib/sentryInit';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'mapbox-gl/dist/mapbox-gl.css';
import { App } from './App';
import { isProductionEnv } from 'utils/env';
import * as Sentry from '@sentry/react';

if (isProductionEnv) {
  //hotjar.initialize(1782133, 6);
}

// Nem o ChunkErrorBoundary (componentDidCatch) nem onRecoverableError disparam pra esse
// erro — ou seja, ele é genuinamente NÃO CAPTURADO por nenhum Error Boundary da árvore.
// onUncaughtError é o gancho nativo do React 18 EXATAMENTE pra esse caso (substitui o
// console.error padrão do React quando nenhum boundary existe acima do ponto do erro) —
// só ele nos dá o componentStack real aqui.
const root = createRoot(document.getElementById('root'), {
  onUncaughtError: (error, errorInfo) => {
    console.error('React onUncaughtError:', error, errorInfo?.componentStack);
    Sentry.captureException(error, {
      contexts: { react: { componentStack: errorInfo?.componentStack } },
      tags: { source: 'onUncaughtError' },
    });
  },
  onRecoverableError: (error, errorInfo) => {
    console.error('React onRecoverableError:', error, errorInfo?.componentStack);
    Sentry.captureException(error, {
      contexts: { react: { componentStack: errorInfo?.componentStack } },
      tags: { source: 'onRecoverableError' },
    });
  },
});
root.render(<App />);
